<head>
  <title>QMS Report page</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb *ngIf="refreshbreadcrumb"></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row ps-0">
  <div class="col-md-8">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email" id="groupNameAlert">Group<span class="mandatory-symbol">*</span> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (keydown.enter)="focusSearch('focus-group-search')" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>


      <div class="col-md-4">
        <div><label for="email"><b>Stage</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedStageValue" (closed)="stageSearchText=''"
          (keydown.enter)="focusSearch('focus-stage-search')" (click)="focusSearch('focus-stage-search')"
          (keydown.enter)="focusSearch('focus-stage-search')">
          <input type="search" id="focus-stage-search" class="dropdownsearchstyle" [(ngModel)]="stageSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onStageValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of stageValueDropdown | assessmentSearch : stageSearchText"
            (onSelectionChange)="onStageValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email"><b>Status</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedStatusValue" (closed)="statusSearchText=''"
          (keydown.enter)="focusSearch('focus-status-search')" (click)="focusSearch('focus-status-search')"
          (keydown.enter)="focusSearch('focus-status-search')">
          <input type="search" id="focus-status-search" class="dropdownsearchstyle" [(ngModel)]="statusSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onStatusValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of statusValueDropdown1 | assessmentSearch : statusSearchText"
            (onSelectionChange)="onStatusValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-2">
        <div>
          <label for="email" id="specifyAlert"><b> Specify Interval </b></label>
        </div>
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal && qmsservice.moduleName !='AU'">
        <div><label for="email" id="groupNameAlert1">Date Range : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="dateRangeSearchText=''"
          (keydown.enter)="focusSearch('focus-group-search')" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-dateRange-search" class="dropdownsearchstyle"
            [(ngModel)]="selectedDateRangeValue" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : dateRangeSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal && qmsservice.moduleName =='AU'">
        <div><label for="email" id="dateRangeAlert">Date Range : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedAuDateRangeValue"
          (closed)="dateRangeSearchText=''" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-dateRanges-search" class="dropdownsearchstyle"
            [(ngModel)]="selectedAuDateRangeValue" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueAuDropDown | assessmentSearch : dateRangeSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <label id="fromDateAlert" for="email"><b>From Date</b> <span class="mandatory-symbol">*</span>: </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate"
          (ngModelChange)="onNgModelChange($event,'fromDateAlert')">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <label for="email" id="toDateAlert"><b>To Date</b><span class="mandatory-symbol">*</span> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate"
          (ngModelChange)="onNgModelChange($event,'toDateAlert')">
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email" id="intervalAlert">Interval : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="intervalSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-interval-search" class="dropdownsearchstyle"
            [(ngModel)]="selectedIntervalValue" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : intervalSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-3">
        <div><label for="email" id="DeptAlert">Department : </label></div>
        <mat-select matInput multiple placeholder="Select" #qmsDeptVal [(ngModel)]="selectedQmsDept"
          (closed)="deptSearchText=''" (click)="focusSearch('focus-qmsDept-search')"
          (keydown.enter)="focusSearch('focus-qmsDept-search')">
          <input type="search" id="focus-qmsDept-search" class="dropdownsearchstyle" [(ngModel)]="deptSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="qmsDeptSelection" (change)="toggleAllSelectionForDept()">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of departmentCodeDropdown | multiAssessmentSearchPipe : deptSearchText"
            [value]="item.valueExp" (onSelectionChange)="onQmsDeptSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2" *ngIf="qmsservice.moduleName =='AU'">
        <label for="email"><b>Show BA Chart</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="showBAChart">
            <span class="active-inActive-container" *ngIf="showBAChart" style="color: green;">Yes</span>
            <span *ngIf="!showBAChart" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="qmsservice.moduleName =='AU' && !showBAChart">
        <div><label for="email" id="annualRefNoAlert">Annual Ref No : </label></div>
        <input type="text" class="form-control" style="padding: 9px 20px;" [(ngModel)]="annualRefNo"
          placeholder="Ref No">
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>

    <!-- First row -->
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Default'}" (click)="moreActivityReportDetails('Default')"
          (keydown.enter)="moreActivityReportDetails('Default')">
          <div class="reports_block">
            <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
          </div>
          <p class="report_subtext">Default</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Performance'}"
          (click)="moreActivityReportDetails('Performance')" (keydown.enter)="moreActivityReportDetails('Performance')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="CR Performance">
          </div>
          <p class="report_subtext">{{qmsservice.moduleName}} Performance</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Pending Actions'}"
          (click)="moreActivityReportDetails('Pending Actions')"
          (keydown.enter)="moreActivityReportDetails('Pending Actions')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/pending.svg" width="16px" height="16px" alt="Pending Actions">
          </div>
          <p class="report_subtext">Pending Actions</p>
        </div>
      </div>
    </div>

    <!-- Second row -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
          (click)="moreActivityReportDetails('Extension')" (keydown.enter)="moreActivityReportDetails('Extension')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
          </div>
          <p class="report_subtext">Extension</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='OOS' && qmsservice.moduleName !='AU' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Effectiveness Check'}"
          (click)="moreActivityReportDetails('Effectiveness Check')"
          (keydown.enter)="moreActivityReportDetails('Effectiveness Check')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px"
              alt="Effectiveness check">
          </div>
          <p class="report_subtext">Effectiveness Check</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName =='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Product Report'}"
          (click)="moreActivityReportDetails('Product Report')"
          (keydown.enter)="moreActivityReportDetails('Product Report')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px" alt="Product Report">
          </div>
          <p class="report_subtext">Product Report</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Action'}" (click)="moreActivityReportDetails('Action')"
          (keydown.enter)="moreActivityReportDetails('Action')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/actions.svg" width="16px" height="16px" alt="Action">
          </div>
          <p class="report_subtext">Actions</p>
        </div>
      </div>
    </div>

    <!-- Third row (AU specific) -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Finding'}" (click)="auditFindingReportDetails('Finding')"
          (keydown.enter)="auditFindingReportDetails('Finding')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/loupe.png" width="16px" height="16px" alt="Finding">
          </div>
          <p class="report_subtext">Finding</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Followup'}"
          (click)="auditFindingReportDetails('Followup')" (keydown.enter)="auditFindingReportDetails('Followup')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/arrow.png" width="16px" height="16px" alt="Followup">
          </div>
          <p class="report_subtext">Followup</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Recommendation'}"
          (click)="auditFindingReportDetails('Recommendation')"
          (keydown.enter)="auditFindingReportDetails('Recommendation')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/question.png" width="16px" height="16px" alt="Recommendation">
          </div>
          <p class="report_subtext" style="font-size: 8px;">Recommendation</p>
        </div>
      </div>
    </div>

    <!-- Fourth row (AU specific FindingDue, FollowupDue, Extension) -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'FindingDue'}" (click)="findingDueDate('FindingDue')"
          (keydown.enter)="findingDueDate('FindingDue')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/date.png" width="16px" height="16px" alt="FindingDue">
          </div>
          <p class="report_subtext">Finding Due</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'FollowupDue'}" (click)="followupDueDate('FollowupDue')"
          (keydown.enter)="followupDueDate('FollowupDue')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/due-date.png" width="16px" height="16px" alt="FollowupDue">
          </div>
          <p class="report_subtext">Followup Due</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='IN'  && qmsservice.moduleName!='QI' ">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
          (click)="moreActivityReportDetails('Extension')" (keydown.enter)="moreActivityReportDetails('Extension')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
          </div>
          <p class="report_subtext">Extension</p>
        </div>
      </div>
    </div>

    <!-- Fifth row: Overdue + Milestone -->
    <div class="row mt-4">
      <div class="col-md-4" *ngIf="qmsservice.moduleName =='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}" (click)="moreActivityReportDetails('Overdue')"
          (keydown.enter)="moreActivityReportDetails('Overdue')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
          </div>
          <p class="report_subtext">Overdue</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}" (click)="moreActivityReportDetails('Overdue')"
          (keydown.enter)="moreActivityReportDetails('Overdue')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
          </div>
          <p class="report_subtext">Overdue</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Milestone'}"
          (click)="moreActivityReportDetails('Milestone')" (keydown.enter)="moreActivityReportDetails('Milestone')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
          </div>
          <p class="report_subtext">Milestone</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Activity Vs User'}"
          (click)="moreActivityReportDetails('Activity Vs User')"
          (keydown.enter)="moreActivityReportDetails('Activity Vs User')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="Activity Vs User">
          </div>
          <p class="report_subtext">Activity Vs User</p>
        </div>
      </div>
    </div>
    <!-- Sixth row: Expand/Collapse + Obsoleted + Deleted -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <!-- Expand/Collapse button -->
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report" (click)="toggleMore()" (keydown.enter)="toggleMore()"
          style="cursor: pointer;">
          <span class="report_subtext">
            {{ showMore ? 'Collapse Reports ◀' : 'Expand More ▶' }}
          </span>
        </div>
      </div>

      <!-- Obsoleted (only visible when expanded) -->
      <div class="col-md-4" *ngIf="showMore && qmsservice.moduleName !='AU' 
                         && qmsservice.moduleName !='CC' 
                         && qmsservice.moduleName !='IN' 
                         && qmsservice.moduleName !='QI'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active': this.qmsservice.reportFor === 'Obsoleted'}"
          (click)="moreActivityReportDetails('Obsoleted')" style="cursor: pointer;"
          (keydown.enter)="moreActivityReportDetails('Obsoleted')">
          <div class="reports_block">
            <img src="../../assets/img/DMS/obsoleted.svg" width="16px" height="16px" alt="Obsoleted">
          </div>
          <p class="report_subtext">Obsoleted</p>
        </div>
      </div>

      <!-- Deleted (only visible when expanded) -->
      <div class="col-md-4" *ngIf="showMore && qmsservice.moduleName !='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active': this.qmsservice.reportFor === 'Deleted'}" (click)="moreActivityReportDetails('Deleted')"
          (keydown.enter)="moreActivityReportDetails('Deleted')" style="cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/delete.svg" width="16px" height="16px" alt="Deleted">
          </div>
          <p class="report_subtext">Deleted</p>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="d-flex gap-3 my-3 ms-2">
  <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="genReport()"
    (keydown.enter)="genReport()">
    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
    <span class="reload_text text-white">Generate</span>
  </div>
  <div *ngIf="showCharts" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
    (click)="exportExcelFromFrontendcall()" (keydown.enter)="exportExcelFromFrontendcall()">
    <i class="fas fa-file-excel"></i>
    <span class="reload_text text-white">Download Count Excel</span>
  </div>
  <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="resetFunction()"
    (keydown.enter)="resetFunction()">
    <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
    <span class="reload_text">Reset</span>
  </div>
</div>
<!-- <hr> -->
<div class="row" *ngIf="showCharts">
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="stageList.length>0 ">
    <canvasjs-chart [options]="chartOptionsForStages" [styles]="{width: '100%', height:'250px'}"
      (dblclick)="chartDoubleClick(1)"></canvasjs-chart>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="stageList.length == 0 ">
    <label for=" "
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins', sans-serif;color:#0F3659;"><b>Stage</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>
  <div class="col-md-8">
    <div class="border rounded-4 p-2" *ngIf="statusList.length>0 ">
      <canvasjs-chart [options]="chartOptionsForStatus" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(2)"></canvasjs-chart>
    </div>
    <div class="border rounded-4 p-2" *ngIf="statusList.length == 0 ">
      <label for=" "
        style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
      <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
    </div>
  </div>
</div>
<div class="row" *ngIf="showCharts">
  <div class="row">
    <div class="col-md-8">
      <div class="border rounded-4 p-2 my-3" *ngIf="departmentList.length>0 ">
        <canvasjs-chart [options]="chartOptionsForDepartment" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(3)"></canvasjs-chart>
      </div>
      <div class="border rounded-4 p-2" *ngIf="departmentList.length == 0 ">
        <label for=" "
          style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins', sans-serif;color:#0F3659;"><b>Department</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
      </div>
    </div>

    <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="qmsservice.moduleName =='OOS' && oosTypeList.length>0 ">
      <canvasjs-chart [options]="chartOptionsForOOSType" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(111)"></canvasjs-chart>
    </div>
    <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="qmsservice.moduleName =='OOS' && oosTypeList.length == 0 ">
      <label for=" "
        style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins', sans-serif;color:#0F3659;"><b>OOS
          Type</b></label>
      <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
    </div>

    <div class="col-md-4" *ngIf="qmsservice.moduleName !='OOS' && taskTypeList.length >0">
      <div class="border rounded-4 p-2 my-3">
        <canvasjs-chart [options]="chartOptionsForTaskType" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(5)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-4 border rounded-4 p-2 " *ngIf="qmsservice.moduleName !='OOS' && taskTypeList.length == 0 ">
      <label for=" "
        style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins', sans-serif;color:#0F3659;"><b>Task
          Type</b></label>
      <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
    </div>

    <div class="col-md-8"
      *ngIf="qmsservice.moduleName !='OOS' && qmsservice.moduleName !='CC' && (showBAChart || qmsservice.moduleName !='AU')">
      <div class="border rounded-4 p-2" *ngIf="baList.length>0">
        <canvasjs-chart [options]="chartOptionsForBa" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(4)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-8"
      *ngIf="qmsservice.moduleName !='OOS' && qmsservice.moduleName !='CC' && baList.length==0 && (showBAChart || qmsservice.moduleName !='AU')">
      <div class=" border rounded-4 p-2">
      <label for=" "
        style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Bussiness
          Area</b></label>
      <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
    </div>
  </div>
  <div class="col-md-4" *ngIf="dueInDaysList.length >0">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForDueInDays" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(15)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="dueInDaysList.length == 0 ">
    <label for=" "
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Due
        In Days</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>
  <div class="col-md-4" *ngIf="specificIntervalVal && activityReportList.length >0">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForActivity" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(6)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="specificIntervalVal && activityReportList.length == 0 ">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Activity
        Report</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>
  <div class="col-md-4" *ngIf="specificIntervalVal &&  inprogressVSTotalList.length>0">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForActivityInprogressVSTotal" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(10)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf=" specificIntervalVal && inprogressVSTotalList.length == 0 ">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Inprogress
        Vs Total</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>

  <div class="col-md-4" *ngIf="specificIntervalVal && extensionList.length>0 ">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForExtention" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(7)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="specificIntervalVal && extensionList.length == 0 ">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Extension</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>
  <div class="col-md-4"
    *ngIf="specificIntervalVal && qmsservice.moduleName!='AU' && qmsservice.moduleName!='CC' && ecList.length>0">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForEC" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(8)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3"
    *ngIf="specificIntervalVal && qmsservice.moduleName!='AU' && qmsservice.moduleName!='CC' && ecList.length == 0 ">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>EC</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>

  <div class="col-md-4" *ngIf="specificIntervalVal && qmsservice.moduleName!='AU' && actionList.length>0">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForAction" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(9)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3"
    *ngIf="specificIntervalVal && qmsservice.moduleName!='AU' && actionList.length == 0">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Action</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>

  <div class="col-md-4" *ngIf="findingList.length>0 &&  qmsservice.moduleName=='AU'">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForFinding" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(11)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-4 mb-3" *ngIf="findingList.length==0 &&  qmsservice.moduleName=='AU'">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Finding</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>

  <div class="col-md-4" *ngIf="followupList.length>0 &&  qmsservice.moduleName=='AU'">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForFollowup" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(12)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="followupList.length==0 &&  qmsservice.moduleName=='AU'">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Followup</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>

  <div class="col-md-4" *ngIf="RecommendationList.length>0 &&  qmsservice.moduleName=='AU'">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForRecommandation" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(13)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="RecommendationList.length==0 &&  qmsservice.moduleName=='AU'">
    <label for=""
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Recommendation
        Count</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>

  <div class="col-md-4" *ngIf="severityList.length>0 &&  qmsservice.moduleName=='AU'">
    <div class="border rounded-4 p-2 mb-3">
      <canvasjs-chart [options]="chartOptionsForSeverity" [styles]="{width: '100%', height:'250px'}"
        (dblclick)="chartDoubleClick(14)"></canvasjs-chart>
    </div>
  </div>
  <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="severityList.length==0 &&  qmsservice.moduleName=='AU'">
    <label for=" "
      style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Finding
        Severity</b></label>
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>
</div>
</div>

<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedType}} : {{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row" *ngIf="clickedStageStatusVal!='' && showReportFlagValue!='5'">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <canvasjs-chart [options]="chartOptionsForStagesStatus"
        [styles]="{width: '100%', height:'350px'}"></canvasjs-chart>
    </div>
  </div>

  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' && this.auditGridFlag =='default'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Au No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempAuNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Au ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Dept Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditCategory', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>End Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('endDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Peer Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extensions</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('extensions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlan', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created From</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedFrom', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Planned By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('plannedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Conduct N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToConductNDaysBefore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Address</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditAddress', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question And Answer Section Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionAndAnswerSectionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Rejected On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleRejectedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Rejected On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planRejectedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOnStr', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Overall OutCome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOverallOutCome', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Outcome Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOutcomeStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Conclusion</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('conclusion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Primary Auditee</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('primaryAuditee', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Score</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.tempAuNo }}</td>
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.startDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.endDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.peerReviewCompletedOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.extensions === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.extensions === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedFrom }}</td>
          <td class="row-data">{{ listOfUsersData.plannedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToConductNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'LEAD_AUDITOR_COMMENTS',listOfUsersData.leadAuditorComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.vendorName }}</td>
          <td class="row-data">{{ listOfUsersData.vendorStatus }}</td>
          <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.auditAddress }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>

          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.initiatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleRejectedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planRejectedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_OVERALL_OUTCOME',listOfUsersData.auditOverallOutcome,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.auditOutcomeStatus }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CONCLUSION',listOfUsersData.conclusion,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.primaryAuditee }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.finalRiskScore }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>

  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName!='AU' ">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div>
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter33(columnLists.columnsListarray[ix],$event)">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData3(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='SHORT_DESCRIPTION'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewShortDescription(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>

            <span *ngIf="key.columnsListarray=='LAST_ACTION_COMMENTS'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewLastActionComment(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='CLOSURE_COMMENTS' && this.qmsservice.moduleName!='CC'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewClosureComment(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='ADDL_COMMENTS'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewLastAddComment(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>

            <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
              {{ list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa'
             && key.columnsListarray!='SHORT_DESCRIPTION' && key.columnsListarray!='IMPACTED_PRODUCT_AND_PROCESS' && key.columnsListarray!='LAST_ACTION_COMMENTS'&& key.columnsListarray!='CLOSURE_COMMENTS'&& key.columnsListarray!='ADDL_COMMENTS'  
             && key.columnsListarray!='OCCURANCE_REASON' && key.columnsListarray!='RESOLUTION_PROVIDED'">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='2'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Current Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('currentDueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension Required Till</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionRequiredTill', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Justification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('justification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approve Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approveRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approvedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('actionDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.extensionId }}</td>
          <td class="row-data">{{ listOfUsersData.currentDueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.extensionRequiredTillStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'JUSTIFICATION',listOfUsersData.justification,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reviewer }}</td>
          <td class="row-data">{{ listOfUsersData.reviewedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REVIEW_COMMENTS',listOfUsersData.reviewComments,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approveRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'APPROVER_COMMENTS',listOfUsersData.approverComments,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.extensionType }}</td>
          <td class="row-data">{{ listOfUsersData.actionDetails }}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='3'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>EC ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter2('ecId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('dueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Methodology</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('methodology', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Criteria</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('criteria', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Conclusion</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('conclusion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Outcome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('outcome', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('closureComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprovalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprovedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprover', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprovalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remind N Days Before Duedate</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('remindNDaysBeforeDueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Seq</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter2('seq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Axis Value</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('axisValue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intervals</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('intervals', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Triggered From EC ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('triggeredFromEcId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Check Reqd For</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('checkReqdFor', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('ownerName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('startDate', $event,'d')" />
            </div>
          </th>


          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.ecId }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.methodology }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CRITERIA',listOfUsersData.criteria,'QMS_ALL_TASK_EC_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CONCLUSION',listOfUsersData.conclusion,'QMS_ALL_TASK_EC_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.outcome }}</td>
          <td class="row-data">{{ listOfUsersData.closureComments }}</td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'APPROVAL_COMMENTS',listOfUsersData.approvalComments,'QMS_ALL_TASK_EC_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.qaApprover }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'QA_APPROVAL_COMMENTS',listOfUsersData.qaApprovalComments,'QMS_ALL_TASK_EC_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.remindNDaysBeforeDueDate }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.seq }}</td>
          <td class="row-data">{{ listOfUsersData.axisValue }}</td>
          <td class="row-data">{{ listOfUsersData.intervals }}</td>
          <td class="row-data">{{ listOfUsersData.triggeredFromEcId }}</td>
          <td class="row-data">{{ listOfUsersData.checkReqdFor }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.ownerName }}</td>
          <td class="row-data">{{ listOfUsersData.startDateStr}}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage3(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
            <button ngbDropdownItem (click)="paginationCall3(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall3(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall3(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='4'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sl No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter3('slNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('startedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Target Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('targetDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Core Business Area</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('coreBusinessArea', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('assignedTo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Performed</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionPerformed', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Defer Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('deferReviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Defer Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('deferApprover', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('createdOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Seq</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter3('seq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Axis Value</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('axisValue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intervals</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('intervals', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems3; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.slNo }}</td>
          <td class="row-data">{{ listOfUsersData.actionId }}</td>
          <td class="row-data">{{ listOfUsersData.actionName }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.targetDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.actionAt }}</td>
          <td class="row-data">{{ listOfUsersData.coreBusinessArea }}</td>
          <td class="row-data">{{ listOfUsersData.assignedTo }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.comments }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.actionPerformed === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.actionPerformed === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reviewer }}</td>
          <td class="row-data">{{ listOfUsersData.reviewStatus }}</td>
          <td class="row-data">{{ listOfUsersData.reviewComments }}</td>
          <td class="row-data">{{ listOfUsersData.reviewCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.approvalStatus }}</td>
          <td class="row-data">{{ listOfUsersData.approvalComments }}</td>
          <td class="row-data">{{ listOfUsersData.approvalCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.deferReviewer }}</td>
          <td class="row-data">{{ listOfUsersData.deferApprover }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.seq }}</td>
          <td class="row-data">{{ listOfUsersData.axisValue }}</td>
          <td class="row-data">{{ listOfUsersData.intervals }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage4(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall4(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall4(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall4(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='5' && this.qmsservice.moduleName=='AU'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter5('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('findingId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Seq</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter5('seq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('finding', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('dueDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('assignedToUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('findingShortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reference</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('reference', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Deliverables</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('deliverables', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Severity</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('severity', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Auditor Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('auditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Root Cause Analysis</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('rootCauseAnalysis', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Immediate Correction</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('immediateCorrection', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Corrective Action</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('correctiveAction', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Preventive Action</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('preventiveAction', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected CA Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expectedCaClosureDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected PA Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expectedPaClosureDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expectedClosureDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Isolated CAPA Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('isCapaRequired', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>CAPA Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('capaDetails', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Reviewed By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewedByUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Reviewer Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewerComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Verification Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseVerificationRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Verified On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseVerifiedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Verification Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseVerificationComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Reviewed By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewedByUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Reviewer Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewerComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Verification Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationVerificationRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Verified On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationVerifiedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Verification Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationVerificationComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Implementation Accepted</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('isImplementaitonAccepted', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('closureComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Score</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('finalRiskScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('createdByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('updatedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.findingId }}</td>
          <td class="row-data">{{ listOfUsersData.seq }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'FINDING',listOfUsersData.finding,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'FINDING_SHORT_DESCRIPTION',listOfUsersData.findingShortDescription,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REFERENCE',listOfUsersData.reference,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'DELIVERABLES',listOfUsersData.deliverables,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.severity }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDITOR_COMMENTS',listOfUsersData.auditorComments,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'ROOT_CAUSE_ANALYSIS',listOfUsersData.rootCauseAnalysis,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'IMMEDIATE_CORRECTION',listOfUsersData.immediateCorrection,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CORRECTIVE_ACTION',listOfUsersData.correctiveAction,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PREVENTIVE_ACTION',listOfUsersData.preventiveAction,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.expectedCaClosureDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedPaClosureDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureDateStr}}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isCapaRequired === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isCapaRequired === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.capaDetails }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewedByUserName }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewStatus }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewerComments }}</td>
          <td class="row-data">{{ listOfUsersData.responseVerificationRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.responseVerifiedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.responseVerificationComments }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewedByUserName }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewStatus }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewerComments }}</td>
          <td class="row-data">{{ listOfUsersData.implementationVerificationRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.implementationVerifiedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.implementationVerificationComments }}</td>
          <td class="row-data">{{ listOfUsersData.isImplementaitonAccepted }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CLOSURE_COMMENTS',listOfUsersData.closureComments,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'COMMENTS',listOfUsersData.comments,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskScore }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
            <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='6'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('findingId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Followup ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('followupId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('auditDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('dueDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('assignedToUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('assignedToUserDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Responses Pending</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('responsesPending', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('createdBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('updatedBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems6; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.findingId }}</td>
          <td class="row-data">{{ listOfUsersData.followupId }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'ASSIGNED_TO_USER_DETAILS',listOfUsersData.assignedToUserDetails,'QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'RESPONSES_PENDING',listOfUsersData.responsesPending,'QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'COMMENTS',listOfUsersData.comments,'QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName}}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
            <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='7'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Recommendation ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('recommendationId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('annualRefNo', $event,'n')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('description', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reference Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('referenceDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Auditee Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('auditeeComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('createdBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('updatedBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems7; let idx = index;">
          <td class="row-data">{{ listOfUsersData.recommendationId }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'DESCRIPTION',listOfUsersData.description,'QMS_ALL_TASK_RECOMMENDATION_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REFERENCE_DETAILS',listOfUsersData.referenceDetails,'QMS_ALL_TASK_RECOMMENDATION_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDITEE_COMMENTS',listOfUsersData.auditeeComments,'QMS_ALL_TASK_RECOMMENDATION_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage7(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic7">
            <button ngbDropdownItem (click)="paginationCall7(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall7(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall7(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='8'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due In Days</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('dueInDays', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Module</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('module', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('expcetedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('taskType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Requested At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('requestedAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Business Area </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('coreBusinessAreaName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('initiatorFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('ownerFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('qaAcceptorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('lastActionOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stop Reminders</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('stopReminders', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Effectiveness Check Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('effectivenessCheckReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('finalNoGenerated', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Investigation Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('investigationRequired', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Investigator Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('investigatorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Q and A Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('isQandaReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems8; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.dueInDays }}</td>
          <td class="row-data">{{ listOfUsersData.module }}</td>
          <td class="row-data">{{ listOfUsersData.expcetedClosureOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.taskType }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName !='AU'">{{ listOfUsersData.requestedAt }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName !='AU'">{{ listOfUsersData.coreBusinessAreaName }}</td>
          <td class="row-data">{{ listOfUsersData.initiatorFullname }}</td>
          <td class="row-data">{{ listOfUsersData.ownerFullname }}</td>
          <td class="row-data">{{ listOfUsersData.qaAcceptorName }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.stopReminders === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.stopReminders === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">{{ listOfUsersData.investigationRequired }}</td>
          <td class="row-data">{{ listOfUsersData.investigatorName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isQandaReqd === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isQandaReqd === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
        </tr>

      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage8(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic8">
            <button ngbDropdownItem (click)="paginationCall8(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall8(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall8(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <!-- plan -->
  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' &&  this.auditGridFlag =='plan'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Au Id</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Au No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempAuNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>End Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('endDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Peer Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extensions</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('extensions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlans', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Scheduled By </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created From
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedFrom', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Planned By User
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('plannedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved By User
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Conduct N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToConductNDaysBefore', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor Comments </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question And Answer Section Type </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionAndAnswerSectionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Expected Closure On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Primary Auditee</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('primaryAuditee', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Updated On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Last Action From Status

            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Sequence </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageSeq', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.tempAuNo }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.startDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.endDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.peerReviewCompletedOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.extensions === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.extensions === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedFrom }}</td>
          <td class="row-data">{{ listOfUsersData.plannedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToConductNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'LEAD_AUDITOR_COMMENTS',listOfUsersData.leadAuditorComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.vendorName }}</td>
          <td class="row-data">{{ listOfUsersData.vendorStatus }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.initiatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.primaryAuditee }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageSeq }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <!-- conduct -->
  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' && this.auditGridFlag =='conduct'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh; ">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Au No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempAuNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Au Id</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditCategory', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>End Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('endDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Peer Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extensions</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('extensions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlans', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Scheduled By </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Expected Closure On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created From </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedFrom', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Planned By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('plannedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Conduct N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToConductNDaysBefore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Status
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question And Answer Section Type
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionAndAnswerSectionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Primary Auditee </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('primaryAuditee', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Overall OutCome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOverallOutCome', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Audit Conclusion </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('conclusion', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Outcome Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOutcomeStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Score </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Updated On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Last Action From Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Sequence </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageSeq', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.tempAuNo }}</td>
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.startDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.endDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.peerReviewCompletedOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.extensions === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.extensions === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedFrom }}</td>
          <td class="row-data">{{ listOfUsersData.plannedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToConductNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'LEAD_AUDITOR_COMMENTS',listOfUsersData.leadAuditorComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.vendorName }}</td>
          <td class="row-data">{{ listOfUsersData.vendorStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.initiatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.primaryAuditee }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_OVERALL_OUTCOME',listOfUsersData.auditOverallOutcome,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CONCLUSION',listOfUsersData.conclusion,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.auditOutcomeStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.finalRiskScore }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageSeq }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' && this.auditGridFlag =='schedule' ">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditCategory', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlans', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Scheduled By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Sequence</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageSeq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageSeq }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel </button>
  </div>
</ng-template>

<!-- Zoom start -->
<ng-template #reportPopupForZoom>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"></label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==1">
      <canvasjs-chart [options]="chartOptionsForStagesZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==2">
      <canvasjs-chart [options]="chartOptionsForStatusZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==3">
      <canvasjs-chart [options]="chartOptionsForDepartmentZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==4">
      <canvasjs-chart [options]="chartOptionsForBaZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==5">
      <canvasjs-chart [options]="chartOptionsForTaskTypeZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==6">
      <canvasjs-chart [options]="chartOptionsForActivityZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==7">
      <canvasjs-chart [options]="chartOptionsForExtentionZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==8">
      <canvasjs-chart [options]="chartOptionsForECZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==9">
      <canvasjs-chart [options]="chartOptionsForActionZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==10">
      <canvasjs-chart [options]="chartOptionsForActivityInprogressVSTotalZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==11">
      <canvasjs-chart [options]="chartOptionsForFindingZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==12">
      <canvasjs-chart [options]="chartOptionsForFollowupZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==13">
      <canvasjs-chart [options]="chartOptionsForRecommandationZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==14">
      <canvasjs-chart [options]="chartOptionsForSeverityZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border rounded-4 p-2 mb-3 " *ngIf="clickedChartVal==15">
      <canvasjs-chart [options]="chartOptionsForDueInDaysZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <!--table start -->
  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' && this.auditGridFlag =='default'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Au No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempAuNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Au ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Dept Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditCategory', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>End Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('endDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Peer Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extensions</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('extensions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlan', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created From</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedFrom', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Planned By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('plannedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Conduct N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToConductNDaysBefore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Address</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditAddress', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question And Answer Section Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionAndAnswerSectionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Rejected On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleRejectedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Rejected On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planRejectedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Questionnaire Sent To Vendor On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionnaireSentToVendorOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Report Sent To Vendor On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reportSentToVendorOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Report Sent To Vendor By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reportSentToVendorBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Overall OutCome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOverallOutCome', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Outcome Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOutcomeStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Conclusion</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('conclusion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Received From Vendor On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('responseReceivedFromVendorOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Score</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.tempAuNo }}</td>
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.startDate | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.endDate | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.peerReviewCompletedOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.extensions === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.extensions === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedOn| date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedFrom }}</td>
          <td class="row-data">{{ listOfUsersData.plannedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToConductNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'LEAD_AUDITOR_COMMENTS',listOfUsersData.leadAuditorComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.vendorName }}</td>
          <td class="row-data">{{ listOfUsersData.vendorStatus }}</td>
          <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.auditAddress }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.initiatedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.scheduleRejectedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planRejectedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.questionnaireSentToVendorOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reportSentToVendorOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.reportSentToVendorBy }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_OVERALL_OUTCOME',listOfUsersData.auditOverallOutcome,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.auditOutcomeStatus }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CONCLUSION',listOfUsersData.conclusion,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.responseReceivedFromVendorOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.finalRiskScore }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>

  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName!='AU'">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div>
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter33(columnLists.columnsListarray[ix],$event)">
              </div>
            </div>
          </th>
        </thead>

        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
'text-overflow': 'ellipsis',
'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt="" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData3(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
              {{ list[key.columnsListarray] }}</span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='2'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionId', $event,'n')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Current Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('currentDueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension Required Till</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionRequiredTill', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Justification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('justification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('reviewComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approve Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approveRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approvedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('approverComments', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('actionDetails', $event,'s')" />
            </div>
          </th>
          <th id="menus" class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.extensionId }}</td>
          <td class="row-data">{{ listOfUsersData.currentDueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.extensionRequiredTillStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'JUSTIFICATION',listOfUsersData.justification,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reviewer }}</td>
          <td class="row-data">{{ listOfUsersData.reviewedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REVIEW_COMMENTS',listOfUsersData.reviewComments,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approveRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'APPROVER_COMMENTS',listOfUsersData.approverComments,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.extensionType }}</td>
          <td class="row-data">{{ listOfUsersData.actionDetails }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='3'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>EC ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter2('ecId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('dueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Methodology</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('methodology', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Criteria</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('criteria', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Conclusion</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('conclusion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Outcome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('outcome', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('closureComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprovalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprovedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprover', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('qaApprovalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remind N Days Before Duedate</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('remindNDaysBeforeDueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Seq</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter2('seq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Axis Value</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('axisValue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intervals</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('intervals', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Triggered From EC ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('triggeredFromEcId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Check Reqd For</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('checkReqdFor', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('ownerName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('startDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.ecId }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.methodology }}</td>
          <td class="row-data">{{ listOfUsersData.criteria }}</td>
          <td class="row-data">{{ listOfUsersData.conclusion }}</td>
          <td class="row-data">{{ listOfUsersData.outcome }}</td>
          <td class="row-data">{{ listOfUsersData.closureComments }}</td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approvalComments }}</td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.qaApprover }}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovalComments }}</td>
          <td class="row-data">{{ listOfUsersData.remindNDaysBeforeDueDate }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.seq }}</td>
          <td class="row-data">{{ listOfUsersData.axisValue }}</td>
          <td class="row-data">{{ listOfUsersData.intervals }}</td>
          <td class="row-data">{{ listOfUsersData.triggeredFromEcId }}</td>
          <td class="row-data">{{ listOfUsersData.checkReqdFor }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.ownerName }}</td>
          <td class="row-data">{{ listOfUsersData.startDateStr}}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage3(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
            <button ngbDropdownItem (click)="paginationCall3(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall3(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall3(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='4'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sl No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter3('slNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('startedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Target Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('targetDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Core Business Area</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('coreBusinessArea', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('assignedTo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Performed</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('actionPerformed', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('reviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Defer Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('deferReviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Defer Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('deferApprover', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('createdOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Seq</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter3('seq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Axis Value</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('axisValue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intervals</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('intervals', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems3; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.slNo }}</td>
          <td class="row-data">{{ listOfUsersData.actionId }}</td>
          <td class="row-data">{{ listOfUsersData.actionName }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.targetDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.actionAt }}</td>
          <td class="row-data">{{ listOfUsersData.coreBusinessArea }}</td>
          <td class="row-data">{{ listOfUsersData.assignedTo }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.comments }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.actionPerformed === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.actionPerformed === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reviewer }}</td>
          <td class="row-data">{{ listOfUsersData.reviewStatus }}</td>
          <td class="row-data">{{ listOfUsersData.reviewComments }}</td>
          <td class="row-data">{{ listOfUsersData.reviewCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.approvalStatus }}</td>
          <td class="row-data">{{ listOfUsersData.approvalComments }}</td>
          <td class="row-data">{{ listOfUsersData.approvalCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.deferReviewer }}</td>
          <td class="row-data">{{ listOfUsersData.deferApprover }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.seq }}</td>
          <td class="row-data">{{ listOfUsersData.axisValue }}</td>
          <td class="row-data">{{ listOfUsersData.intervals }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage4(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall4(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall4(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall4(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='5' && this.qmsservice.moduleName=='AU'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter5('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('findingId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Seq</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter5('seq', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('finding', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('dueDateStr', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('assignedToUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('findingShortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reference</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('reference', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Deliverables</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('deliverables', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Severity</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('severity', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Auditor Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('auditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Root Cause Analysis</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('rootCauseAnalysis', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Immediate Correction</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('immediateCorrection', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Corrective Action</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('correctiveAction', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Preventive Action</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('preventiveAction', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected CA Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expectedCaClosureDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected PA Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expectedPaClosureDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expectedClosureDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Isolated CAPA Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('isCapaRequired', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>CAPA Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('capaDetails', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Reviewed By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewedByUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Reviewer Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewerComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Verification Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseVerificationRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Verified On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseVerifiedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Verification Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseVerificationComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Reviewed By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewedByUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Reviewer Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewerComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Verification Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationVerificationRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Verified On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationVerifiedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Verification Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationVerificationComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Implementation Accepted</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('isImplementaitonAccepted', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('closureComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Score</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('finalRiskScore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('responseReviewRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Implementation Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('implementationReviewRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('createdByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('updatedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.findingId }}</td>
          <td class="row-data">{{ listOfUsersData.seq }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'FINDING',listOfUsersData.finding,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'FINDING_SHORT_DESCRIPTION',listOfUsersData.findingShortDescription,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REFERENCE',listOfUsersData.reference,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'DELIVERABLES',listOfUsersData.deliverables,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.severity }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDITOR_COMMENTS',listOfUsersData.auditorComments,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'ROOT_CAUSE_ANALYSIS',listOfUsersData.rootCauseAnalysis,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'IMMEDIATE_CORRECTION',listOfUsersData.immediateCorrection,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CORRECTIVE_ACTION',listOfUsersData.correctiveAction,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PREVENTIVE_ACTION',listOfUsersData.preventiveAction,'QMS_ALL_TASKS_FINDINGS_CLOSUREINDAYS_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.expectedCaClosureDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedPaClosureDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureDateStr}}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isCapaRequired === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isCapaRequired === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.capaDetails }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewedByUserName }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewStatus }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewerComments }}</td>
          <td class="row-data">{{ listOfUsersData.responseVerificationRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.responseVerifiedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.responseVerificationComments }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewedByUserName }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewStatus }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewCompletedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewerComments }}</td>
          <td class="row-data">{{ listOfUsersData.implementationVerificationRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.implementationVerifiedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.implementationVerificationComments }}</td>
          <td class="row-data">{{ listOfUsersData.isImplementaitonAccepted }}</td>
          <td class="row-data">{{ listOfUsersData.closureComments }}</td>
          <td class="row-data">{{ listOfUsersData.comments }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskScore }}</td>
          <td class="row-data">{{ listOfUsersData.responseReviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.implementationReviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
            <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='6'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('findingId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Followup ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('followupId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('auditDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('dueDateStr', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('assignedToUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('assignedToUserDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Responses Pending</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('responsesPending', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('createdBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('updatedBy', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems6; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.findingId }}</td>
          <td class="row-data">{{ listOfUsersData.followupId }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'ASSIGNED_TO_USER_DETAILS',listOfUsersData.assignedToUserDetails,'QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'RESPONSES_PENDING',listOfUsersData.responsesPending,'QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'COMMENTS',listOfUsersData.comments,'QMS_ALL_TASK_FOLLOWUPS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName}}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
            <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>

  <div class="table-container" *ngIf="showReportFlagValue=='7'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Recommendation ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('recommendationId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('description', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reference Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('referenceDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Auditee Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('auditeeComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('createdBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('updatedBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter7('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems7; let idx = index;">
          <td class="row-data">{{ listOfUsersData.recommendationId }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.description }}</td>
          <td class="row-data">{{ listOfUsersData.auditeeComments }}</td>
          <td class="row-data">{{ listOfUsersData.referenceDetails }}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage7(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic7">
            <button ngbDropdownItem (click)="paginationCall7(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall7(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall7(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='8'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due In Days</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('dueInDays', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Module</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('module', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('expcetedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('taskType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Requested At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('requestedAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Business Area </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('coreBusinessAreaName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('initiatorFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('ownerFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('qaAcceptorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('lastActionOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stop Reminders</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('stopReminders', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Effectiveness Check Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('effectivenessCheckReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('finalNoGenerated', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Investigation Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('investigationRequired', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Investigator Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('investigatorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Q and A Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('isQandaReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter8('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems8; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.dueInDays }}</td>
          <td class="row-data">{{ listOfUsersData.module }}</td>
          <td class="row-data">{{ listOfUsersData.expcetedClosureOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.taskType }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName !='AU'">{{ listOfUsersData.requestedAt }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName !='AU'">{{ listOfUsersData.coreBusinessAreaName }}</td>
          <td class="row-data">{{ listOfUsersData.initiatorFullname }}</td>
          <td class="row-data">{{ listOfUsersData.ownerFullname }}</td>
          <td class="row-data">{{ listOfUsersData.qaAcceptorName }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.stopReminders === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.stopReminders === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">{{ listOfUsersData.investigationRequired }}</td>
          <td class="row-data">{{ listOfUsersData.investigatorName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isQandaReqd === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isQandaReqd === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
        </tr>

      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage8(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic8">
            <button ngbDropdownItem (click)="paginationCall8(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall8(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall8(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <!-- plan -->
  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' &&  this.auditGridFlag =='plan'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Au Id</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Au No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempAuNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDate', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startDate', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>End Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('endDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Peer Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extensions</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('extensions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlans', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Scheduled By </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedOn', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created From
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedFrom', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Planned By User
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('plannedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved By User
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Conduct N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToConductNDaysBefore', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor Comments </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question And Answer Section Type </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionAndAnswerSectionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Expected Closure On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Questionnaire Sent To Vendor On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionnaireSentToVendorOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Report Sent To Vendor By </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reportSentToVendorBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Received From Vendor On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('responseReceivedFromVendorOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Updated On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Last Action From Status

            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Sequence </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageSeq', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.tempAuNo }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.startDate | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.endDate | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.peerReviewCompletedOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.extensions === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.extensions === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedOn| date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedFrom }}</td>
          <td class="row-data">{{ listOfUsersData.plannedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToConductNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'LEAD_AUDITOR_COMMENTS',listOfUsersData.leadAuditorComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.vendorName }}</td>
          <td class="row-data">{{ listOfUsersData.vendorStatus }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.initiatedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.questionnaireSentToVendorOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reportSentToVendorOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.reportSentToVendorBy }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageSeq }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>


  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' && this.auditGridFlag =='conduct'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh; ">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Au No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempAuNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Au Id</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditCategory', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDate', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startDate', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>End Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('endDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Peer Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewCompletedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extensions</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('extensions', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlans', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Scheduled By </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Expected Closure On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedOnStr', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Created From </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planCreatedFrom', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Planned By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('plannedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Conduct N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToConductNDaysBefore', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Vendor Status
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('vendorStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Question And Answer Section Type
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionAndAnswerSectionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiated On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On
            </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Questionnaire Sent To Vendor On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('questionnaireSentToVendorOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Report Sent To Vendor On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reportSentToVendorOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Report Sent To Vendor By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reportSentToVendorBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Response Received From Vendor On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('responseReceivedFromVendorOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Overall OutCome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOverallOutCome', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Audit Conclusion </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('conclusion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Outcome Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditOutcomeStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Score </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskScore', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskStatus', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Updated On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Last Action From Status </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Sequence </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageSeq', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.tempAuNo }}</td>
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.startDate | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.endDate | date:'dd-MMM-yyyy HH:mm:ss' }}</td>

          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.peerReviewCompletedOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.extensions === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.extensions === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr }}</td>

          <td class="row-data">{{ listOfUsersData.planCreatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planCreatedFrom }}</td>
          <td class="row-data">{{ listOfUsersData.plannedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToConductNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'LEAD_AUDITOR_COMMENTS',listOfUsersData.leadAuditorComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.vendorName }}</td>
          <td class="row-data">{{ listOfUsersData.vendorStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.questionAndAnswerSectionType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.initiatedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.questionnaireSentToVendorOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reportSentToVendorOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.reportSentToVendorBy }}</td>
          <td class="row-data">{{ listOfUsersData.responseReceivedFromVendorOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_OVERALL_OUTCOME',listOfUsersData.auditOverallOutcome,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CONCLUSION',listOfUsersData.conclusion,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>


          <td class="row-data">{{ listOfUsersData.auditOutcomeStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.finalRiskScore }}</td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOn | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOn | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOn | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageSeq }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <!-- scahudle -->
  <div class="table-container"
    *ngIf="showReportFlagValue=='1' && this.qmsservice.moduleName=='AU' && this.auditGridFlag =='schedule' ">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div> &nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Functional Area Or Sevices</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('functionalAreaOrServices', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Category</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditCategory', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Classification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditClassification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Proposed Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditProposedDate', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Multiple Plan</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('multiplePlans', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleStatus', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Scheduled By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduledByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedByUser', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Lead Auditor User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('leadAuditorUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intimate To Plan N Days Before</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intimateToPlanNDaysBefore', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Purpose</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditPurpose', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Scope</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditScope', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit References </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditReferences', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Executive Summary </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('executiveSummary', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approval Requested On </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApprovedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Plan Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('planApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovalRequestedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApprovedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Schedule Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('scheduleApproverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remarks</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('remarks', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span> Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Sequence</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageSeq', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Risk Calculation Reqd</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isRiskCalculationReqd', $event,'s')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.scheduleNo }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.functionalAreaOrServices }}</td>
          <td class="row-data">{{ listOfUsersData.auditType }}</td>
          <td class="row-data">{{ listOfUsersData.auditCategory }}</td>
          <td class="row-data">{{ listOfUsersData.auditClassification }}</td>
          <td class="row-data">{{ listOfUsersData.auditProposedDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.multiplePlans === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.multiplePlans === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleStatus }}</td>
          <td class="row-data">{{ listOfUsersData.scheduledByUser }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedByUser }}</td>
          <td class="row-data">{{ listOfUsersData.leadAuditorUser }}</td>
          <td class="row-data">{{ listOfUsersData.intimateToPlanNDaysBefore }}</td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expectedClosureOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_PURPOSE',listOfUsersData.auditPurpose,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_SCOPE',listOfUsersData.auditScope,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'AUDIT_REFERENCES',listOfUsersData.auditReferences,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'EXECUTIVE_SUMMARY',listOfUsersData.executiveSummary,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.planApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.planApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'PLAN_APPROVER_COMMENTS',listOfUsersData.planApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.scheduleApprovedOnStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'SCHEDULE_APPROVER_COMMENTS',listOfUsersData.scheduleApproverComments,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REMARKS',listOfUsersData.remarks,'QMS_AU_TASKS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdOn | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOn | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOn | date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageSeq }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isRiskCalculationReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <!--table end-->
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupForZoomFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 12 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6" *ngIf="!isForExcel">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>


      <div class="row justify-content-md-center" *ngIf="!isForExcel">
        <div class="col-sm-4">
          <label for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
            (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-sm-8">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
              (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <input type="search" id="focus-footer-search" class="dropdownsearchstyle"
                [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">

              <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="!isForExcel">
        <div class="col-sm-4">
          <label for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label for="email">Report Name</label>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label id="pdf-select-all" for="email">Select Column(s)</label><span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput multiple placeholder="Select" #pdf [(ngModel)]="selectedColumns"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection('pdf')"> Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{item.displayExp}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>